import React from 'react'
import { Redirect, Route } from 'react-router-dom'

export const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      localStorage.getItem('user-enatega') ? (
        // Sales agents only have the agent portal.
        (() => { try { return JSON.parse(localStorage.getItem('user-enatega')).userType === 'AGENT' } catch (e) { return false } })() ? (
          <Redirect to={{ pathname: '/agent/home' }} />
        ) : (
          <Component {...props} />
        )
      ) : (
        <Redirect
          to={{
            pathname: '/auth/login',
            state: { from: props.location }
          }}
        />
      )
    }
  />
)
